import { render, staticRenderFns } from "./PaymentMethodRules.vue?vue&type=template&id=6910bd32&"
import script from "./PaymentMethodRules.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports